import {
  EDITOR_MODE,
  useBlocksConfig,
  useEditorMode
} from "@pathwright/blocks-engine"
import { BlockText, QuillEditor, SubText } from "@pathwright/blocks/src/shared"
import { sansSerifStyles } from "@pathwright/blocks/src/ui/typography"
import { isEmptyHTML } from "@pathwright/blocks/src/utils"
import { TOOLBAR_CONFIG_TYPES } from "@pathwright/ui/src/components/quill/toolbar/QuillToolbar"
import get from "lodash/get"
import React from "react"
import styled from "styled-components"

export const QuestionTitle = styled.h5`
  width: 100%;
  margin: 0;
  ${sansSerifStyles({ size: 26 })}
  font-weight: 700;
  font-style: normal;
  color: #2a2e33;
  line-height: 32px;

  /* styles to apply to quill editor content */
  & > p,
  .ql-editor,
  .ql-editor p,
  .BlockText,
  .BlockText p,
  .ContentText,
  .ContentText.ql-editor,
  .ContentText.ql-editor .BlockText,
  .ContentText.ql-editor .BlockText p {
    margin: 0;
    font-size: inherit;
    font-size: 26px;
    font-weight: inherit;
    font-family: inherit;
    line-height: inherit;
  }
`

const QuestionHeader = ({
  onChange,
  data,
  descriptionStyle = { edit: {} },
  preview
}) => {
  const { templateVariables } = useBlocksConfig()
  const { mode } = useEditorMode() || {}

  if (mode === EDITOR_MODE.EDIT && !preview)
    return (
      <React.Fragment>
        <QuestionTitle>
          <QuillEditor
            toolbar={TOOLBAR_CONFIG_TYPES.SIMPLE}
            html={data.question}
            placeholder={"Enter your question"}
            onChange={(question) => onChange({ question })}
            controlled
          />
        </QuestionTitle>
        <QuillEditor
          toolbar={TOOLBAR_CONFIG_TYPES.SIMPLE}
          createCustomToolbar={({ getMergedToolbarConfig }) =>
            getMergedToolbarConfig({
              config: [[{ list: "ordered" }, { list: "bullet" }]]
            })
          }
          html={data.description}
          placeholder={"Add a description (optional)"}
          style={{ marginTop: 10, ...descriptionStyle.edit }}
          onChange={(description) => onChange({ description })}
        />
      </React.Fragment>
    )

  const description = get(data, "description", "").startsWith("<p>")
    ? data.description
    : "<p>" + data.description + "</p>"

  return (
    <React.Fragment>
      <QuestionTitle>
        <BlockText html={data.question} templateContext={templateVariables} />
      </QuestionTitle>
      {data.description && !isEmptyHTML(description) ? (
        <SubText
          style={{ marginTop: 8, padding: "2px 0" }}
          html={description}
          templateContext={templateVariables}
        />
      ) : null}
    </React.Fragment>
  )
}

export default QuestionHeader
